import React from "react";

const Footer = () => {

    return (
        <div className="main-footer">
            <p className="footer-copyright">
                Proprietary Copyright Intellectual Property of IMU Studios Inc.
            </p>
            <p className="footer-version">
                Tool ver. 1.0
            </p>
        </div>
    );

}

export default Footer;